import { useGlobalStore } from "../context/UserContext/userContext";
import { handleTokenExpired } from "./helper";
import { refreshAccessToken } from "../api/httpClients/tokenRefreshCoordinator";

export async function fetchWithAuth(url, options) {
  const store = useGlobalStore.getState();
  const { isWixAuth } = store;

  try {
    let token = await store.getAccessToken();
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers,
    };

    let response = await fetch(url, { ...options, headers });

    if (response.status !== 401) return response;

    if (isWixAuth) {
      handleTokenExpired();
      return response;
    }

    try {
      token = await refreshAccessToken();
      response = await fetch(url, {
        ...options,
        headers: { ...headers, Authorization: `Bearer ${token}` },
      });
      if (response.status === 401) handleTokenExpired();
      return response;
    } catch (refreshError) {
      console.error("Token refresh failed:", refreshError);
      handleTokenExpired();
      return response;
    }
  } catch (error) {
    if (isWixAuth) {
      handleTokenExpired();
      throw error;
    }
    try {
      const token = await refreshAccessToken();
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...options.headers,
      };
      return await fetch(url, { ...options, headers });
    } catch (refreshError) {
      console.error("Token refresh failed:", refreshError);
      handleTokenExpired();
      throw error;
    }
  }
}
